// extracted by mini-css-extract-plugin
export default {"stack":"TechStack_stack__Wqj3T","groupName":"TechStack_groupName__zvgPH","icons":"TechStack_icons__ya9NK"};